import React from 'react'

import SafeAndSecure from '~/public/static/images/svg/shieldCheck.svg'

const SafeAndSecureLogo = (props) => {
  return (
    <img src={SafeAndSecure} style={props.style} alt="Safe and secure" />
  )
}

export default SafeAndSecureLogo
